import { render, staticRenderFns } from "./CancelSchoolOrderModal.vue?vue&type=template&id=19d0edf7"
import script from "./CancelSchoolOrderModal.vue?vue&type=script&lang=ts"
export * from "./CancelSchoolOrderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports